import React, { useEffect, useState } from "react";
import Axios from 'services/BackendApi/BackendApi';
import styles from './SideMenu.module.scss';
import { Navbar, Nav, Button } from "react-bootstrap";
import { BoxArrowDownRight } from "react-bootstrap-icons";
import { useLocation, matchPath, Link } from 'react-router-dom';
import { memberof } from "modules/user/actions/userActions";
import logo from 'assets/img/poweredByGLIFOS.png';
/*
    PENDIENTE:
        -   Aquí se debe de integrar de alguna manera el React Redux para manejar los puntos
            pendientes o las notificacion de globito para cada opción.

*/
export default function SideMenu(props) {
    const { options } = props;
    const { pathname } = useLocation();
    const [reservas, setReservas] = useState([]);

    const handleClick = () => {
        window.open('https://glifos.com/library', '_blank');
    };


    useEffect(() => {
        getReservas()
    }, []);

    const handleStorageChange = () => {
        setReservas(localStorage.getItem('reservas'));
    };

    useEffect(() => {
        window.addEventListener('storage', handleStorageChange);
        setReservas(localStorage.getItem('reservas'));
        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);

    async function getReservas() {
        let carrito = await Axios.GetCarrito({ urlParams: "1" });
        setReservas(carrito.data.length);
    }


        return <Nav variant="pills" className={`flex-column mb-auto ${styles.navContainer}`}>

            {
                (props.logo) ?
                    <>
                        <Navbar.Brand className={styles.navbarbrand}>
                            <img
                                src={props.logo}
                                width="40%"
                                height="auto"
                                className="d-inline-block align-top"
                                alt={props.logoalt ? props.logoalt : ''}
                            />
                        </Navbar.Brand>
                        <hr />
                    </>
                    :
                    ""
            }

            {
                options.map((op, idx) => {
                    if (op.roles) {
                        if (!memberof(op.roles)) {
                            return "";
                        }
                    }
                    if ((op.variant) && (op.variant == "divider")) {
                        return <div key={idx}><hr />{op.label}</div>;
                    }
                    let isActive = matchPath({ path: op.route }, pathname);
                    if (!isActive && op.alias?.length > 0) {
                        op.alias.map((rt, idx) => {
                            let thisActive = matchPath({ path: rt }, pathname);
                            if (!isActive) isActive = (thisActive) ? true : false;
                            return "";
                        })
                    }
                    if ((op.variant) && (op.variant == "external")) {
                        return (
                            <a href={op.route} className={`${styles.navlink} nav-link`} target="_blank" key={idx}>
                               {op.icon && <div className={styles.icon}>{<op.icon />}</div>}
                               <span className={styles.label}>{op.label}</span>
                            </a>
                        ); 
                    }
                    else {
                        return <Nav.Item key={idx}>
                            {/*<Nav.Link href={op.route} className={styles.navlink + ((isActive)?" active":"")}>*/}
                            {(op.label == "Carrito") ?

                                <Link to={op.route} className={styles.navlink + " nav-link " + ((isActive) ? styles.myactive/*" active"*/ : "")}>
                                    {(op.icon) ? op.icon : ""} {op.label}
                                    {(reservas > 0) ? <span className={styles.notification}>{reservas}</span> : null}
                                </Link> :
                                <Link to={op.route} className={styles.navlink + " nav-link " + ((isActive) ? styles.myactive/*" active"*/ : "")}>
                                    {(op.icon) ? op.icon : ""} {op.label}
                                </Link>
                            }
                            {/*</Nav.Link>*/}
                        </Nav.Item>;
                    }
                })
            }

            <Navbar.Brand className={styles.navbarlogo}>
                <img
                    src={logo}
                    width="50%"
                    height="auto"
                    onClick={handleClick}
                    className="d-inline-block align-top"
                    alt='powered by GLIFOS'
                />
            </Navbar.Brand>

        </Nav>;


} 